import React, { useState, useRef } from "react";

export default function OtpField({ length = 6, onComplete }) {
  const [otp, setOtp] = useState(Array(length).fill(""));
  const inputRefs = useRef([]);

  const handleChange = (index, event) => {
    const value = event.target.value.replace(/\D/, "");
    if (!value) return;

    const newOtp = [...otp];
    newOtp[index] = value.slice(-1);
    setOtp(newOtp);

    console.log("OTP corrente:", newOtp.join(""));

    if (newOtp.every((digit) => digit !== "") && onComplete) {
      console.log("Completato OTP:", newOtp.join(""));
      onComplete(newOtp.join(""));
    }

    if (index < length - 1 && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (index, event) => {
    if (event.key === "Backspace") {
      const newOtp = [...otp];

      if (!otp[index] && index > 0) {
        newOtp[index - 1] = "";
        inputRefs.current[index - 1].focus();
      } else {
        newOtp[index] = "";
      }

      setOtp(newOtp);

      const updatedCode = newOtp.join("");
      if (onComplete) onComplete(updatedCode);
    }
  };

  const handlePaste = (event) => {
    event.preventDefault();
    const pasteData = event.clipboardData.getData("text").replace(/\D/g, ""); // Get only digits

    if (!pasteData) return;

    const newOtp = [...otp];
    for (let i = 0; i < length; i++) {
      newOtp[i] = pasteData[i] || "";
    }

    setOtp(newOtp);

    if (newOtp.every((digit) => digit !== "") && onComplete) {
      onComplete(newOtp.join(""));
    }

    // Move focus to the last filled input
    const nextEmptyIndex = newOtp.findIndex((digit) => digit === "");
    if (nextEmptyIndex !== -1) {
      inputRefs.current[nextEmptyIndex].focus();
    } else {
      inputRefs.current[length - 1].blur(); // Remove focus if all are filled
    }
  };

  return (
    <div className="flex items-center justify-center">
      {otp.map((digit, index) => (
        <React.Fragment key={index}>
          {index === 3 && (
            <span className="mx-3 text-2xl font-bold text-black">-</span>
          )}
          <input
            ref={(el) => (inputRefs.current[index] = el)}
            type="text"
            value={digit}
            onChange={(e) => handleChange(index, e)}
            onKeyDown={(e) => handleKeyDown(index, e)}
            onPaste={handlePaste} // Add paste support
            className={`w-[50px] h-[60px] md:w-[70px] md:h-[80px] text-center text-[24px] md:text-[38px] font-sb border-2 border-gray-200 focus:border-3 focus:border-black focus:outline-none ${
              index > 0 ? "-ml-[2px]" : ""
            } ${
              index === 0 || index === 3
                ? "rounded-l-[10px] rounded-r-none"
                : ""
            } ${
              index === 2 || index === 5
                ? "rounded-r-[10px] rounded-l-none"
                : ""
            } ${
              (index > 0 && index < 2) || (index > 3 && index < 5)
                ? "rounded-none"
                : ""
            }
 z-10
 hover:z-20 focus:z-50
 `}
            maxLength="1"
          />
        </React.Fragment>
      ))}
    </div>
  );
}
